import React, { useEffect, useRef, useState } from 'react';
import './circularprogressbar.css';

const CircularProgressBar = ({ size = 120, strokeWidth = 10, percentage = 75, duration = 1500, marginTop = 0 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.3,
      }
    );

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progressTime = timestamp - start;
      const current = Math.min((progressTime / duration) * percentage, percentage);
      setProgress(current);
      if (current < percentage) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [isVisible, percentage, duration]);

  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div
      ref={ref}
      className="progress-wrapper"
      style={{ width: size, height: size, marginTop }}
    >
      <svg width={size} height={size}>
        <circle
          className="progress-bg"
          stroke="#eee"
          strokeWidth={strokeWidth}
          fill="none"
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          className="progress-bar"
          stroke="#3e98c7"
          strokeWidth={strokeWidth}
          fill="none"
          r={radius}
          cx={size / 2}
          cy={size / 2}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
        />
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize="18"
          fill="#3e98c7"
        >
          {Math.round(progress)}%
        </text>
      </svg>
    </div>
  );
};

export default CircularProgressBar;
